export const SET_PUBLIC_SCREENS_TOKENS = 'SET_PUBLIC_SCREENS_TOKENS'
export const RESET_MODULE_STATE = 'RESET_MODULE_STATE'
export const SET_DAILY_RESERVATIONS_THEME_SETTINGS =
  'SET_DAILY_RESERVATIONS_THEME_SETTINGS'
